import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export enum CreditSafeInternationalScoreEnum {
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D',
    E = 'E',
    NotRated = 'Not Rated',
    BankruptcyProceedingsFiled = 'Bankruptcy proceedings filed',
}

export const CreditSafeInternationalScoreSchema = z.object({
    value: EnumSchema(CreditSafeInternationalScoreEnum),
});

export class CreditSafeInternationalScore extends FromSchema(CreditSafeInternationalScoreSchema) {
    value: CreditSafeInternationalScoreEnum;
}
